import { atom } from 'jotai';
import { WabaLevelUserPermissionsResponse } from '../typings/waba-level-permission';
import { createRequestAtom } from '../utils/request-atom';

export const wabaLevelPermissionsAtom = createRequestAtom<WabaLevelUserPermissionsResponse>();
